import {
    SET_COMPLETE_STATE_DATA,
    SET_COMPLETE_CITY_DATA,
    SET_COMPLETE_PIN_CODE_DATA,
    SET_CUMULATION_DATA,
} from './types'


const initialState = {
    completeState: [],
    completeCity: [],
    completePinCode: [],
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_COMPLETE_STATE_DATA:
            return {
                ...state,
                completeState: payload
            }

        case SET_COMPLETE_CITY_DATA:
            return {
                ...state,
                completeCity: payload
            }

        case SET_CUMULATION_DATA:
            return {
                ...state,
                cumulationData: payload
            }

        case SET_COMPLETE_PIN_CODE_DATA:
            return {
                ...state,
                completePinCode: payload
            }

        default:
            return state;
    }
}